import * as React from "react";

const ChevronUpAux: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="14"
            viewBox="0 0 24 14"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <polygon
                transform="translate(12.000000, 6.720000) rotate(-90.000000) translate(-12.000000, -6.720000) "
                points="17.5866975 5.40076301 8.39261698 -5.28 5.28 -2.64154637 13.3408035 6.72001017 5.28 16.0815464 8.39261698 18.72 17.5866975 8.03923699 18.72 6.72001017"
            ></polygon>
        </svg>
    );
};

export default React.memo(ChevronUpAux);
